<template>
  <button
    class="history-back"
    type="button"
    @click="() => $store.dispatch('historyBack')"
    v-if="this.$store.state.finder.history.length > 0"
  >
    <Icon id="chevron-left" />
  </button>
</template>

<script>
import Icon from '@/components/Icon.vue';

export default {
  components: {
    Icon,
  },
};
</script>

<style scope lang="scss">
.history-back {
  @include resetButtonStyle;
  color: $color-primary;
  animation: fadeIn .2s ease-out;
}
</style>
